import * as React from 'react'
import {observer} from 'mobx-react'
import {IMaskInput} from 'react-imask'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {ErrorMessage} from '../../../ui/ErrorMessage'
import {IconMobile, IconNoSMS} from '../../../ui/Icons'
import {FormPart} from '../../../wrappers/FormPart'
import {DirtyWrapper} from '../../../wrappers/DirtyWrapper'
import {InputWrapper} from '../../../wrappers/InputWrapper'
import {
  countryCodeCH,
  getMsisdnMaskProps,
  omitCountryCode,
} from '../../../../lib/helpers'

///////////////////////////////////////////////////////////////////////////////

export const OverlaySmsPollChangeNumber = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const form = api.paymentForm
  const formData = form.data
  const errors = form.validationErrors
  const msisdn = omitCountryCode(formData.msisdn || '')
  const setMsisdn = (value) => (formData.msisdn = value)
  const cancel = () => api.forceCancelTransaction()
  const submit = () => form.validateAndSend()
  const msisdnMaskProps = getMsisdnMaskProps(setMsisdn)

  return (
    <FormPart className="overlay-sms-poll-change-number" onSubmit={submit}>
      <div className="header">
        <IconNoSMS />
      </div>
      <div className="main">
        <div className="subtitle">
          <h2 className="text">
            {api.trans('blocks.overlay_sms_poll_change_number.subtitle')}
          </h2>
        </div>
        <div
          className="text"
          dangerouslySetInnerHTML={{
            __html: api.trans(
              'blocks.overlay_sms_poll_change_number.text_html',
            ),
          }}
        />

        <div className="form-block msisdn">
          <div className="field-block">
            <label
              className="label-block"
              htmlFor={api.ui.generateUniqueElementId('msisdn')}
            >
              {api.trans('payment_form.msisdn')}
            </label>
            <InputWrapper form={form} fields="msisdn">
              <DirtyWrapper form={form} fields="msisdn">
                <IMaskInput
                  {...msisdnMaskProps}
                  type="tel"
                  id={api.ui.generateUniqueElementId('msisdn')}
                  aria-label={api.trans('payment_form.msisdn')}
                  aria-describedby={api.ui.generateUniqueElementId(
                    'msisdn-error',
                  )}
                  className="input-text"
                  name="msisdn"
                  placeholder={api.trans('payment_form.placeholders.msisdn')}
                  value={msisdn}
                  inputMode="tel"
                  autoComplete="tel-national"
                />
              </DirtyWrapper>
            </InputWrapper>

            <IconMobile />
            <span className="country-code">{countryCodeCH}</span>
          </div>

          <ErrorMessage
            errors={errors}
            errorKey="msisdn"
            id={api.ui.generateUniqueElementId('msisdn-error')}
          />
        </div>
      </div>
      <div className="actions">
        <button
          type="button"
          className="btn btn-primary action-submit"
          onClick={submit}
        >
          <span className="btn-text">
            {api.trans('blocks.overlay_sms_poll_change_number.resend_sms')}
          </span>
        </button>
        <button type="button" className="action-cancel" onClick={cancel}>
          <span className="link">
            {api.trans('blocks.overlay_sms_poll_change_number.cancel')}
          </span>
        </button>
      </div>
    </FormPart>
  )
})
